module.exports = __webpack_public_path__ + "img/article2.3fa2a380.jpg";